import React, { useRef } from "react";
import { FiDownload, FiPlus, FiSearch, FiUpload } from "react-icons/fi";

export default function ClientToolbar({
  searchTerm,
  onSearchChange,
  onAdd,
  onImport,
  onExport,
}) {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file && onImport) onImport(file);
    event.target.value = "";
  };

  return (
    <div className="mb-5 rounded-lg border bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="relative w-full lg:max-w-xl">
          <FiSearch className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search by name, PAN, GSTIN, contact, mobile or email"
            className="w-full rounded-md border py-2 pl-10 pr-3 focus:border-blue-500 focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {onAdd && <button
            type="button"
            onClick={onAdd}
            className="inline-flex items-center gap-2 rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700"
          >
            <FiPlus /> Add Client
          </button>}

          {onImport && <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
            className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
          >
            <FiUpload /> Import Excel
          </button>}

          <button
            type="button"
            onClick={onExport}
            className="inline-flex items-center gap-2 rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
          >
            <FiDownload /> Export Excel
          </button>

          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
}
